import React from 'react'
import { Route } from 'mobx-router'
import BatchEditPage from './components/page/batch_edit'
import CItemList from './components/contractitems/list'
import CItemsEdit from './components/contractitems/manip'
import ChangelogPage from './components/page/changelog'
import EntityEdit from './components/page/entity_edit'
import EntityList from './components/page/entity_list'
import EnumEditPage from './components/page/enumedit'
import EtlRunnerPage from './components/page/etl_page'
import HistoryDetail from './components/archive/manip'
import LoginPage from './components/page/login'
import ReportPage from './components/page/report'
import UpdatePage from './components/page/update'
import UploadsPage from './components/page/uploads'
import * as linkConst from './constants/link_constants'

const checkUpdate = store => {
  if (store.newVersion && store.activeUploads <= 0) {
    store.router.goTo(store.views.update, {}, store, {})
    return false
  }
}

const views = {
  login: new Route({
    path: '/',
    component: <LoginPage />,
    beforeEnter: (route, params, store) => {
      store.router.params.entityname = null
    }
  }),
  changelog: new Route({
    path: '/changelog',
    component: <ChangelogPage />,
    beforeEnter: (route, params, store) => {
      store.router.params.entityname = 'changelog'
    }
  }),
  update: new Route({
    path: '/update',
    component: <UpdatePage />,
    beforeEnter: (route, params, store) => {
      store.router.params.entityname = 'update'
    }
  }),
  uploads: new Route({
    path: '/uploads',
    component: <UploadsPage />,
    beforeEnter: (route, params, store, queryParams) => checkUpdate(store)
  }),
  etl_runner: new Route({
    path: '/' + linkConst.LINK_ETL_RUNNER,
    component: <EtlRunnerPage />,
    beforeEnter: (route, params, store) => {
      store.runnerNavStatusSet(null)
      store.router.params.entityname = linkConst.LINK_ETL_RUNNER
      store.loadEtlRunner()
    },
    beforeExit: (route, params, store, queryParams) => {
      !store.runnerNavStatus && clearInterval(store.runnerInterval)
    }
  }),
  entity_list: new Route({
    path: '/entity/:entityname',
    component: <section className='entity-list'><EntityList /></section>,
    beforeExit: (route, params, store, queryParams) => {
      return store.beforeListViewExit(route, params, store, queryParams)
    },
    beforeEnter: (route, params, store, queryParams) => {
      store.beforeListViewEnter(route, params, store, queryParams)
      return checkUpdate(store)
    },
    onEnter: (route, params, store) => {
      store.showEntityListView(params.entityname)
    },
    onParamsChange: (route, origParams, store, origQueryParams) => {
      store.onListParamsChange(origParams, origQueryParams)
    }
  }),
  entity_detail: new Route({
    path: '/entity/:entityname/:id',
    component: <section className='entity-edit'><EntityEdit /></section>,
    beforeEnter: (route, params, store, queryParams) => checkUpdate(store),
    beforeExit: (route, params, store, queryParams) => {
      store.lastEdited = params.id
      return store.beforeEditViewExit()
    },
    onEnter: (route, params, store) => {
      store.showEntityUpdateView(params.entityname, params.id)
    },
    onParamsChange: (route, origParams, store) => {
      if (store.router.params.entityname !== origParams.entityname) {
        store.cv.flagEditDone(origParams.entityname, origParams.id)
      }
      store.showEntityUpdateView(store.router.params.entityname, store.router.params.id)
    }
  }),
  report: new Route({
    path: `/${linkConst.LINK_REPORT_VIEW}/:id`,
    component: <ReportPage />,
    beforeEnter: (route, params, store, queryParams) => checkUpdate(store),
    onEnter: (route, params, store) => {
      store.router.params.entityname = linkConst.LINK_REPORT_VIEW
      store.showReportView(params.id)
    },
    onParamsChange: (route, origParams, store) => {
      store.changeReport(store.router.params.id)
    }
  }),
  enum_edit: new Route({
    path: `/${linkConst.LINK_ENUMS}/:id?`,
    component: <EnumEditPage />,
    beforeEnter: (route, params, store, queryParams) => checkUpdate(store),
    onEnter: (route, params, store) => {
      store.router.params.entityname = linkConst.LINK_ENUMS
      store.showEnumEdit(params.id)
    }
  }),
  batch_edit: new Route({
    path: '/batch/:operation/:entityname',
    component: <BatchEditPage />,
    beforeEnter: (route, params, store, queryParams) => checkUpdate(store),
    onEnter: (route, params, store, queryParams) => {
      store.showBatchEdit(params.operation, params.entityname, queryParams.ids)
    }
  }),
  history_detail: new Route({
    path: '/history/:entityname/:id',
    component: <HistoryDetail />,
    beforeEnter: (route, params, store, queryParams) => checkUpdate(store),
    onEnter: (route, params, store) => store.showHistoryDetail(params)
  }),
  contractitems: new Route({
    path: '/:entname/citems/:id',
    component: <CItemList />,
    beforeEnter: (route, params, store, queryParams) => checkUpdate(store),
    onEnter: (route, params, store) => store.showContractItems(params),
    onParamsChange: (route, origParams, store, origQueryParams) => {
      store.contractItemsParChange(origParams, origQueryParams)
    }
  }),
  contractitem_detail: new Route({
    path: '/:entname/:eid/citem/:id',
    component: <CItemsEdit />,
    beforeEnter: (route, params, store, queryParams) => checkUpdate(store),
    onEnter: (route, params, store) => store.showContractItemDetail(params),
    beforeExit: (route, params, store, queryParams) => {
      // save id of edited item 2B able to scrollTo
      store.lastEdited = params.id
      store.cv.flagEditDone()
    }
  })
}
export default views
